import { Button } from "src/@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "src/@/components/ui/dialog"
import { Input } from "src/@/components/ui/input"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "src/@/components/ui/select"
import { Switch } from "src/@/components/ui/switch"
import { RowInput } from "src/components/forms/RowInput"
import { Label } from "src/@/components/ui/label"

export default function ModalScoring({
  open,
  onClose,
  onSubmit,
  action,
  nome,
  changeNome,
  tipo,
  changeTipo,
  pontos,
  changePontos,
  status,
  changeStatus
}) {

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>
            {action === "Criar" ? "Criar regra de score" : "Editar regra de score"}
          </DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <RowInput
            label="Nome"
            input={<Input
              onChange={changeNome}
              value={nome}
              placeholder="Ex: Respondeu email"
            />}
          />
          <RowInput
            label="Tipo"
            input={
              <Select value={tipo} onValueChange={changeTipo}>
                <SelectTrigger className="w-full">
                  <SelectValue placeholder="Selecione o tipo" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="credit">Crédito (+)</SelectItem>
                  <SelectItem value="debit">Débito (-)</SelectItem>
                </SelectContent>
              </Select>
            }
          />
          <RowInput
            label="Pontos"
            input={<Input
              type="number"
              min="1"
              onChange={changePontos}
              value={pontos}
              placeholder="Ex: 10"
            />}
          />
          <div className="flex items-center space-x-2">
            <Switch
              checked={status === "true"}
              onCheckedChange={(checked) => changeStatus(checked ? "true" : "false")}
            />
            <Label className="text-sm text-gray-600">Ativo</Label>
          </div>
        </div>
        <DialogFooter>
          <Button onClick={onSubmit}>{action === "Criar" ? "Criar" : "Salvar"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
